export const phrases = {

	'host': 'hôte',
	'hosts': 'hôtes',
	'service': 'service',
	'services': 'services',

	'pending': 'en attente',
	'up': 'en haut',
	'down': 'vers le bas',
	'unreachable': 'inaccessible',
	'acked': 'reconnaître',
	'scheduled': 'prévu',
	'flapping': 'battement',
	'ok': 'bien',
	'warning': 'attention',
	'critical': 'critique',
	'unknown': 'inconnu',
	
	'host up': 'hôte en haut',
	'host down': 'hôte vers le bas',
	'host unreachable': 'hôte inaccessible',
	'service ok': 'service en haut',
	'service warning': 'service attention',
	'service critical': 'service critique',
	'service unknown': 'service inconnu',

	'soft': 'doux',
	'hard': 'fort',

	'Last OK': 'Dernière fois bon',
	'Last UP': 'Dernière fois en haut',
	'Last check was': 'Le dernier chèque était',
	'Next check in': 'Prochain enregistrement dans',
	'ago': '',

	'All': 'Tout',
	'hosts are UP': 'hôtes sont bons',
	'services are OK': 'services sont bons',

	'history': 'l\'histoire',
	'alerts in the past': 'alertes dans le passé',
	'trimming at': 'couper à',

	'quiet': 'calme',

	'on': 'sur',
	'is': 'est',
	'and': 'et',

	'show filters': 'afficher les filtres',
	'last update': 'dernière mise à jour',
	'settings': 'réglages',

	'newest first': 'le plus récent d\'abord',
	'oldest first': 'le plus ancien en premier',

	"show more": "montre plus",
	"show less": "montre moins",

	"day": "journée",
	"days": "journées",
	"hour": "heure",
	"hours": "heures",
	"minute": "minute",
	"minutes": "minutes",
	"second": "second",
	"seconds": "seconds"

};